module.exports = __webpack_public_path__ + "static/media/pt-PT.d55be69f.md";